/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Cta_LeadInputs */

const en_mk_sec_pg_cta_lead = /** @type {(inputs: Mk_Sec_Pg_Cta_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We would rather answer before you sign up than disappoint you afterwards.`)
};

const id_mk_sec_pg_cta_lead = /** @type {(inputs: Mk_Sec_Pg_Cta_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami lebih suka menjawab sebelum Anda mendaftar daripada mengecewakan sesudahnya.`)
};

/**
* | output |
* | --- |
* | "We would rather answer before you sign up than disappoint you afterwards." |
*
* @param {Mk_Sec_Pg_Cta_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_cta_lead = /** @type {((inputs?: Mk_Sec_Pg_Cta_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Cta_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_cta_lead(inputs)
	return en_mk_sec_pg_cta_lead(inputs)
});